import { post, get, put, _delete } from './Tools';

const obtenerTodosHistoricos = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}historico_nomina/`);
  return response;
};

const crearHistorico = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}historico_nomina/`, payload);
  return response;
};

const obtenerHistoricosPorEmpleado = async (odooEmpleadoId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}historico_nomina/empleado/${odooEmpleadoId}`);
  return response;
};

const obtenerHistoricosPorPeriodo = async (periodoId, anio, numero) => {
  const response = await get(`${process.env.REACT_APP_SERVER}historico_nomina/periodo/${periodoId}/${anio}/${numero}`);
  return response;
};

const obtenerHistoricoPorId = async (historicoId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}historico_nomina/${historicoId}`);
  return response;
};

const actualizarHistorico = async (historicoId, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}historico_nomina/${historicoId}`, payload);
  return response;
};

const eliminarHistorico = async (historicoId) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}historico_nomina/${historicoId}`);
  return response;
};


export { obtenerTodosHistoricos, crearHistorico, obtenerHistoricosPorEmpleado, obtenerHistoricosPorPeriodo, obtenerHistoricoPorId, actualizarHistorico, eliminarHistorico};